import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
const ResultsWrapper = ({ children, useStyle, }) => {
    if (useStyle) {
        return (_jsxs(StyledResults, { children: [_jsx("div", { className: "line" }), _jsx("ul", { className: "typeahead-list", children: children })] }));
    }
    else {
        return (_jsxs("div", { className: "", children: [_jsx("div", { className: "line" }), _jsx("ul", { className: "typeahead-list", children: children })] }));
    }
};
export default ResultsWrapper;
const StyledResults = styled.div `
  > div.line {
    border-top-color:
    border-top-style: solid;
    border-top-width: 1px;

    margin-bottom: 0px;
    margin-left: 14px;
    margin-right: 20px;
    margin-top: 0px;
    
    padding-bottom: 4px;
  }

  > ul {
    z-index: 100;
    list-style-type: none;
    margin: 0;
    padding: 0px 0 16px 0;
    max-height: 10px;
    position: relative;

    > li {
      display: flex;
      align-items: center;
      background-color: #ffffff;
      border-color: #e5e5e4;
      border-style: solid;
      border-width: 0.5px;

      &:hover {
        background-color: #e5e5e4;
        cursor: pointer;
      }

      > div {
        margin-left: 13px;
      }
    }
  }

  .liContainer {
    width:100%;
    margin:0;
    padding: 8px 12px;

  }

  .ellipsis {
    text-align: left;
    width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .selected {
    background-color: #e5e5e4;
  }
`;
